import React from 'react'
import "./Footer.css"
import { useNavigate } from 'react-router-dom'
import { INSTAGRAM_URL } from '../../utils/links'

function Footer() {
  const navigate = useNavigate()
  return (
     <footer>
      <div className="container">
        
        {/* --- TOP SECTION: CONTACT & SOCIAL --- */}
        <div className="text-center">
          <h4 className="footer-contact-heading">Contact us</h4>
          <div className="footer-social-icons">
            <a href={INSTAGRAM_URL} target='_blank' rel='noopener noreferrer'>
              <img loading="lazy" decoding="async" src={require("../../assets/images/instragram-color.png")} alt='instragram' />
            </a>
             <a href='https://www.facebook.com/camphornbillcorbett?mibextid=ZbWKwL' target='_blank'>
              <img loading="lazy" decoding="async" src={require("../../assets/images/facebook-color.png")} alt='facebook' />
            </a>
            <a href='https://www.google.com/travel/search?q=google%20reviews%20camp%20hornbill&g2lb=4814050%2C4874190%2C4893075%2C4899571%2C4899572%2C4965990%2C4969803%2C72277293%2C72302247%2C72317059%2C72406588%2C72414906%2C72421566%2C72471280%2C72472051%2C72473841%2C72481459%2C72485658%2C72536387%2C72602734%2C72614662%2C72616120%2C72619927%2C72620306%2C72647020%2C72648289%2C72658035%2C72671093%2C72686036%2C72726180%2C72749221%2C72757848%2C72770823&hl=en-IN&gl=in&ssta=1&ts=CAEaRwopEicyJTB4MzkwYTEyYTJkMjRmOGI4MzoweGE3Y2JhNGRlODhhMzI0ZDcSGhIUCgcI6A8QChgHEgcI6A8QChgIGAEyAhAA&qs=CAEyFENnc0kxOG1NeGVpYjZlV25BUkFCOAJCCQnXJKOI3qTLp0IJCdcko4jepMun&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwiYwKC75_eIAxUAAAAAHQAAAAAQEg' target='_blank'>
              <img loading="lazy" decoding="async" src={require("../../assets/images/google-color.png")} alt='google' />
            </a>
            <a href='https://www.youtube.com/@camphornbillcorbett' target='_blank'>
              <img loading="lazy" decoding="async" src={require("../../assets/images/youtube-color.png")} alt='youtube' />
            </a>
          </div>
        </div>

        {/* --- TOP DIVIDER --- */}
        <hr className="footer-divider" />

        {/* --- MIDDLE SECTION: LOGO & NAV --- */}
        <div className="footer-middle-section">
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-4">
            
            <div className="footer-logo">
              <img loading="lazy" decoding="async" src={require("../../assets/images/logo.png")} alt="Camp Hornbill" />
            </div>

            <ul className="footer-nav justify-content-center">
              <li><a onClick={() => navigate("/")}>Home</a></li>
              <li><a onClick={() => navigate("/experience")}>Experience</a></li>
              <li><a onClick={() => navigate("/stay")}>Stay</a></li>
              <li><a onClick={() => navigate("/learning")}>Learning & Groups</a></li>
              <li><a onClick={() => navigate("/family-retreats")}>Family Retreats</a></li>
              <li><a onClick={() => navigate("/community-Conservation")}>Community & Conservation</a></li>
              <li><a onClick={() => navigate("/our-story")}>Our Story</a></li>
              <li><a onClick={() => navigate("/gallery")}>Gallery</a></li>
              <li><a onClick={() => navigate("/contact-us")}>Contact Us</a></li>
            </ul>

          </div>
        </div>

        {/* --- BOTTOM DIVIDER --- */}
        <hr className="footer-divider" />

        {/* --- BOTTOM SECTION: COPYRIGHT --- */}
        <div className="footer-copyright">
          Camphornbill COPYRIGHT ©2026 ALL RIGHTS RESERVED
        </div>

      </div>
    </footer>
  )
}

export default Footer